import { global, roundUpToAndDivisibleByN } from '.';
import * as R from 'ramda';
export const countDecimals = (value) => {
    if (Math.floor(value) === value)
        return 0;
    return (value === null || value === void 0 ? void 0 : value.toString().split('.')[1].length) || 0;
};
export const countDecimalsMinTwo = (num) => {
    const numDecimals = countDecimals(num);
    return numDecimals < 2 ? 2 : numDecimals;
};
export const limitInputToPositiveValue = (currentTarget) => {
    const { value } = currentTarget;
    if (value === '') {
        return '';
    }
    if (value.indexOf('-') > -1 || isNaN(Number(value))) {
        return 0;
    }
    if (value.length > 1 &&
        value[0] === '0' &&
        value[1] !== '0' &&
        value.indexOf('.') === -1) {
        /*
         * Number inputs like 0123 would fall in this case.
         * Keep the 0 at start, in case user wants to type a dot so that it becomes 0.123.
         * If we don't handle this case, user can never type a 0 at front if there is an existing number in input,
         * because Number(0123) === 123.
         */
        return '0' + Number(value);
    }
    if (value.length > 1 && value[0] === '.') {
        /*
         * Number inputs like .123 would fall in this case.
         * Keep the dot at front in case user wants to add a number before it.
         */
        return '.' + Number(value.slice(1));
    }
    return Number(value);
};
export const formatDecimalValue = (value, decimals = 2, unit) => {
    return value !== undefined
        ? `${value.toFixed(decimals)}${unit ? ` ${unit}` : ''}`
        : global.NOT_AVAILABLE;
};
export const roundToRelativeScale = (numToRoundUp, roundUpOnly = false) => {
    if (numToRoundUp === 0) {
        return numToRoundUp;
    }
    const [integer, decimal] = String(numToRoundUp).split('.');
    if (decimal && decimal.length === 0) {
        return Number(roundUpToAndDivisibleByN(numToRoundUp, 1));
    }
    else {
        if (integer.length > 3) {
            return roundUpOnly
                ? Number(roundUpToAndDivisibleByN(numToRoundUp, Math.pow(10, integer.length - 1) / 10))
                : Number(numToRoundUp.toFixed(1));
        }
        else if (integer.length <= 3 && integer.length > 1) {
            return roundUpOnly
                ? Number(roundUpToAndDivisibleByN(numToRoundUp, Math.pow(10, integer.length) / 10))
                : Number(numToRoundUp.toFixed(1));
        }
        else if (decimal) {
            let validCount = true;
            const numOfZeros = R.filter((x) => {
                if (validCount) {
                    if (x !== 0) {
                        validCount = false;
                    }
                    return true;
                }
                return false;
            }, decimal.split('')).length;
            const multiplyer = Math.pow(10, numOfZeros + 1);
            const roundedNumber = roundUpOnly
                ? Math.ceil(numToRoundUp * multiplyer) / multiplyer
                : Math.round(numToRoundUp * multiplyer) / multiplyer;
            return Number(roundedNumber);
        }
        else {
            return numToRoundUp;
        }
    }
};
export const formatNumber = (x, decimalPoints) => {
    const str = decimalPoints ? x.toFixed(decimalPoints) : x.toString();
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
